/**
 * registrantHeaders.js
 *
 * Defines the headers for the registrant data table.
 * Each object represents a column in the table, including display text, value key, alignment, and sortability.
 */

export default [
  {
    text: 'Name', // Registrant's full name
    value: 'name',
    align: 'start',
  },
  {
    text: 'Account Created', // Date the account was created
    value: 'dateCreated',
  },
  {
    text: 'Email Address', // Registrant's email address
    value: 'email',
  },
  {
    text: 'Company', // Registrant's company
    value: 'company',
  },
  {
    text: 'Role', // Registrant's role
    value: 'role',
  },
  {
    text: 'Note', // Last note added for the registrant
    value: 'lastNote',
    sortable: false,
  },
  {
    text: 'Status', // Current status of the registrant
    value: 'status',
    sortable: false,
  },
  {
    text: 'Actions', // Action buttons (e.g., edit, delete)
    value: 'action',
    sortable: false,
  },
];
